import toast from 'react-hot-toast';
import Icon from '../assets/images/icon.png';

const checkToast = (message) => {
  toast(message, {
    icon: '⚠️'
  });
};

const messageToast = ({message, description}) => {
  toast.custom(
    (t) => (
      <div
        style={{
          opacity: t.visible ? 1 : 0,
          transition: 'opacity 1000ms ease-in-out',
          width: '552px',
          height: '140px',
          background: '#1f1f1f',
          color: '#fff',
          borderRadius: '30px',
          fontSize: '25px',
          boxShadow: '0px 2px 7px 0px rgba(0, 0, 0, 0.15)',
        }}
        className={'flex justify-left items-center'}
      >
          <img src={Icon} alt="icon" className="ml-7 w-[92px]" />
          <div className={'ml-5 flex items-left flex-col'}>
              <div className={'text-[25px] text-[#fff] font-[pd-b] max-w-[380px] text-left'}>
                  {message}
              </div>
              {description && (
                    <div className={'text-[20px] text-[#fff] font-[pd-b]  opacity-40 max-w-[380px]  text-left'}>
                        {description}
                    </div>
              )}
          </div>
      </div>
    ),
      {
          duration: 3000,
          position: 'bottom-center', // 👈 토스트를 화면 아래 중앙에 위치하게 설정
      }
  );
};

export {checkToast, messageToast};
